import React from 'react';
import { motion } from 'framer-motion';
const BARS = [0, 0.12, 0.24, 0.06];

/** Small four-bar meter marking the row that is currently sounding. */
export function NowPlayingBars({
  playing
}: {
  playing: boolean;
}) {
  return <span className="flex h-4 items-end gap-[2px]" aria-hidden="true" data-id="element-64" data-mp="ozli4xpm0d3n">
      {BARS.map((delay, i) => <motion.span key={i} className="w-[2px] rounded-full bg-gold" initial={{
      height: 4
    }} animate={playing ? {
      height: [4, 14, 7, 12, 5]
    } : {
      height: 4
    }} transition={playing ? {
      duration: 1.1,
      repeat: Infinity,
      repeatType: 'mirror',
      ease: 'easeInOut',
      delay
    } : {
      duration: 0.15,
      ease: [0.23, 1, 0.32, 1]
    }} data-id="element-65" data-mp="k1a8oo3884ly" data-mpi={i} />)}
    </span>;
}